import React from 'react';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { connect } from 'react-redux';
import { useLocalErrorHandler, useMultiSearch } from 'hooks';
import { IPayloadExpertExams } from 'components/models';
import ExpertDetailsTabs from 'components/ExpertTabs/ExpertDetailsTabs';

const ExpertContainer: React.FC<Props> = (props) => {
    useLocalErrorHandler(props.setErrorHandler);
    const examFilters = useMultiSearch<IPayloadExpertExams>(props.getExamsList, { expertId: props.expertId || '' });

    React.useEffect(() => {
        if (props.expertId) {
            const fetchPersonalData = async () => {
                await props.getPersonalData(props.expertId);
                props.getAsc({ pageSize: 500 });
                props.getExamsList(examFilters.filters);
            };

            fetchPersonalData();
        }
    }, [props.expertId, props.getCertificateList, props.getPersonalData]);

    return (
      <ExpertDetailsTabs
        exams={props.examsList}
        getExams={examFilters.changeFilter}
        details={props.personalData}
        apiError={props.apiError}
        getExpertChangeRequestsHistory={props.getExpertChangeRequestsHistory}
        clearExpertChangeRequestsHistory={props.clearExpertChangeRequestsHistory}
        historyExpertChanges={props.historyExpertChanges}
      />
    );
};

const mapState = (state: IRootState) => ({
    apiError: state.errors.error,
    personalData: state.expert.personalData,
    historyExpertChanges: state.expertChanges.historyExpertChanges,
    certificateList: state.expert.certificateList,
    attestationSubCommissions: state.asc.ascList,
    examsList: state.expert.examsList,
    loadingDetails: Boolean(state.loading.effects.expert.getPersonalDataAsync),
});

const mapDispatch = (dispatch: Dispatch) => ({
    getPersonalData: dispatch.expert.getPersonalDataAsync,
    getExpertChangeRequestsHistory: dispatch.expertChanges.getExpertChangeRequestsHistory,
    clearExpertChangeRequestsHistory: () => dispatch.expertChanges.setHistoryExpertChangeRequests(null),
    getCertificateList: dispatch.expert.getCertificateListAsync,
    getExamsList: dispatch.expert.getExamsListAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
    getAsc: dispatch.asc.getAscAsync,
});

export default connect(mapState, mapDispatch)(ExpertContainer);

interface OwnProps {
    expertId: string;
}

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
type Props = connectedProps & OwnProps;
